import React from "react";
import ProjectLink from "notifications/components/project_link";

const PresentationLink = ({ project, presentation }) => {
  return (
    <ProjectLink
      project={project}
      append={`presentations/${presentation.id}/`}
      linkTitle={presentation.name}
    />
  );
};

export default PresentationLink;
